export const PAGE_URI = `comparison/`;

export const CONNECTOR_URL = `/assets/components/comparison/connector.php`;

export const RequestAction = {
  REMOVE_PRODUCT: `remove_product`,
};
